<template>
  <div class="content--body mt-3 ml-2 mr-2">
    <h2 class="content_title mb-3">
      Dados do livro
    </h2>

    <HeaderFinalizarImportacao v-if="livroSelecionado"
                               class="mb-2"
                               :livro="livroSelecionado"
                               :origem="origem" />

    <div class="row">
      <div class="col-12 col-sm-4 form-group">
        <label for="perfil">
          Perfil
        </label>

        <select id="perfil"
                v-model="perfil"
                v-validate="'required'"
                class="custom-select custom-select-sm"
                :class="{ 'is-invalid': errors.has('perfil') }"
                name="perfil"
                required>
          <option v-for="item in profiles"
                  :key="item.id"
                  :value="item.id">
            {{ item.desc }}
          </option>
        </select>

        <small v-if="errors.has('perfil')"
               class="invalid-feedback">
          {{ errors.first('perfil') }}
        </small>
      </div> 

      <FileUpload class="col-12 col-sm-4 form-control-sm mt-4 pt-2"
                  label="Selecionar todas imagens"
                  :sm="true"
                  @onSelectFiles="onSelectFiles" />
    </div>

    <OptionsLote v-if="selectedFiles.length"
                 :page="page"
                 :per-pag="perPage"
                 :last-page="lastPage"
                 :show-all-info="true"
                 :accept-select-all="selectedShowFiles.filter(file => file.flag_isento).length === livroSelecionado.registros.length"
                 :enable-select-all="false"
                 @selectAllFiles="selectAllFiles"
                 @nextPage="nextPage"
                 @previousPage="previousPage"
                 @updatePerPage="updatePerPage" />

    <GridLoteArquivos v-if="selectedFiles.length > 0"
                      class="mt-3"
                      :arquivos="selectedFiles"
                      :perfil="perfil"
                      :data-averb-all="dataAverbAll"
                      :profiles="profiles"
                      @atualizarPerfil="atualizarPerfil"
                      @removeSelectedFiles="removeSelectedFiles"
                      @onSelectFiles="onSelectFiles" />

    <OptionsLote v-if="selectedFiles.length > 0"
                 class="mb-4"
                 :page="page"
                 :per-pag="perPage"
                 :last-page="lastPage"
                 :show-all-info="false"
                 @nextPage="nextPage"
                 @previousPage="previousPage" />

    <BoxImportarLote v-if="selectedFiles.length > 0"
                     :perfil="perfil"
                     :upload-complete="uploadComplete"
                     :isento="selectAll"
                     :origem="origem"
                     :prop-selected-files="selectedFiles"
                     @changeDataAverbacaoAll="changeDataAverbacaoAll"
                     @removeFiles="removeFiles"
                     @onClickUpload="onClickUpload" />
  </div>
</template>

<script>
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  // Components
  import FileUpload from '@/components/SofiaRei/Upload/FileUpload'
  import OptionsLote from '@/components/SofiaRei/ImportarImagensEmLote/OptionsLote'
  import BoxImportarLote from '@/components/SofiaRei/ImportarImagensEmLote/BoxImportarLote'
  import GridLoteArquivos from '@/components/SofiaRei/ImportarImagensEmLote/GridLoteArquivos'
  import ListagemLoteRegistro from '@/components/SofiaRei/ImportarImagensEmLote/ListagemLoteRegistro'
  import HeaderFinalizarImportacao from '@/components/SofiaRei/ImportarImagensEmLote/HeaderFinalizarImportacao'

  // Services
  import LivroService from '@/services/LivroService'
  import RegistrosService from '@/services/Registros'
  import FileUploadService from '@/services/Arquivos/FileUploadService'

  // Constants
  import { STATUS_PENDING, STATUS_SUCCESS, STATUS_ERROR } from '@/constants/fileUpload'

  export default {
    name: 'FimImportacaoImagensEmLote',
    components: {
      FileUpload,
      OptionsLote,
      BoxImportarLote,
      GridLoteArquivos,
      ListagemLoteRegistro,
      HeaderFinalizarImportacao
    },
    data () {
      return {
        // LIVRO ou REGISTRO
        origem: null,
        livroSelecionado: null,
        profiles: [],
        perfil: 1,
        isUploading: false,
        uploadComplete: false,
        selectedFiles: [],

        // REGISTRO
        selectedItems: [],

        // Paginação
        page: 1,
        perPage: 100,
        lastPage: 1,
        selectedShowFiles: [],
        selectAll: false,
        dataAverbAll: null
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        loteRegistrosSelecionados: 'lote/getRegistrosSelecionados'
      })
    },
    watch: {
      // Atualiza o codigo do perfil nos documentos
      perfil: function (newVal) {
        if (!this.selectedFiles.length) return 

        for (const selectedFile of this.selectedFiles) {
          selectedFile.codigo_perfil_ged = newVal
        }
      }
    },
    async beforeMount () {
      if (!this.$route.name || ['lote_livro', 'lote_registro'].indexOf(this.$route.name) === -1) {
        this.$router.push({ name: 'pageNotFound' })
      }

      loader({ active: true, text: 'Aguarde...' })

      try {
        this.origem = this.$route.name === 'lote_livro' ? 'LIVRO' : 'REGISTRO'

        if (this.origem === 'REGISTRO' && !this.loteRegistrosSelecionados.length) {
          this.$router.push({ name: 'importar_imagens_em_lote' })
        }

        if (this.origem === 'LIVRO') {
          this.livroSelecionado = await LivroService.getLivroById(this.$route.params.id)
        } else {
          const registroSelecionado = this.loteRegistrosSelecionados[0]

          this.livroSelecionado = {
            acervo: registroSelecionado.acervo,
            livro_id: registroSelecionado.livro_id,
            num_livro: registroSelecionado.num_livro,
            primeiro_termo: registroSelecionado.termo,
            qtd_registros: this.loteRegistrosSelecionados.length,
            registros: this.loteRegistrosSelecionados,
            tipo_livro: registroSelecionado.tipo_livro,
            ultimo_termo: this.loteRegistrosSelecionados[this.loteRegistrosSelecionados.length - 1].termo
          }
        }


        for (let i = 0; i < this.livroSelecionado.registros.length; i++) {
          const indexSelectedFiles = this.selectedFiles.length
          this.selectedFiles.push({
            disabled: false,
            status: STATUS_PENDING,
            file: null,
            flag_isento: false,
            data_documento: null,
            registro: this.livroSelecionado.registros[indexSelectedFiles],
            registro_id: this.livroSelecionado.registros[indexSelectedFiles].registro_id,
            cartorio_id: this.cartorioId,
            codigo_perfil_ged: this.perfil
          })
        }

        this.selectShowFiles()
        

        this.profiles = await RegistrosService.perfilRegistro(this.livroSelecionado.tipo_livro)

        if (!this.livroSelecionado || !this.livroSelecionado.registros.length) {
          this.$router.push({ name: 'pageNotFound' })
        }

        if (this.origem === 'REGISTRO') {
          this.livroSelecionado.qtd_registros = this.loteRegistrosSelecionados.length
          this.livroSelecionado.primeiro_termo = this.loteRegistrosSelecionados[0].termo
          this.livroSelecionado.ultimo_termo = this.loteRegistrosSelecionados[this.loteRegistrosSelecionados.length - 1].termo
        }
      } catch (e) {
        this.$router.push({ name: 'pageNotFound' })
      } finally {
        loader({ active: false, text: '' })
      }
    },
    methods: {
      // Seleciona os arquivos
      onSelectFiles (files, item) {

        if (!files.length) {
          this.selectedFiles = []
          return
        }
        if (files.length > 500) {
          return this.onError('Selecionou mais que o limite de registro do livro. Limite máximo 500.')
        }
        if (files.length > this.livroSelecionado.registros.length) {
          return this.onError('Selecionou mais arquivos do que a quantidade de registros.')
        }
        if (item) {
          const registro = this.selectedFiles.find(element => item.registro_id === element.registro_id)
          registro.file = files[0]

          const registroShow = this.selectedShowFiles.find(element => item.registro_id === element.registro_id)
          registroShow.file = files[0]
        } else {
          for (let i = 0; i < files.length; i++) {
            const item = this.selectedFiles[i]
            item.file = files[i]
            item.fileName = files[i].name
          }
        }


        // this.selectShowFiles()
      },
      selectShowFiles () {
        // Page
        const indexInit = this.perPage * (this.page - 1)
        const indexFim = (this.perPage * this.page) - 1

        const selectedShowFilesTmp = []

        this.selectedFiles.forEach(function (selected, index) {
          if (index >= indexInit && index <= indexFim) {
            selectedShowFilesTmp.push(selected)
          }
        })

        this.selectedShowFiles = selectedShowFilesTmp

        // Last Page
        this.lastPage = Math.ceil(this.selectedFiles.length / this.perPage)
      },
      removeSelectedFiles (item) {
        this.selectedFiles.forEach(registro => {
          if (registro.registro_id === item.registro_id) {
            registro.file = null
            registro.fileName = null
          }
        })
      },
      // Paginação
      selectAllFiles (val) {
        this.selectAll = val

        this.selectedFiles.map(item => {
          item.flag_isento = val
          item.data_documento = item.flag_isento ? this.dataAverbAll : null
        })
      },
      nextPage (nextPag) {
        this.page = nextPag
        this.unCheckRegistos()
      },
      previousPage (previousPag) {
        this.page = previousPag
        this.unCheckRegistos()
      },
      updatePerPage (val) {
        this.perPage = val
        this.unCheckRegistos()
      },
      unCheckRegistos () {
        this.selectAll = false
        this.selectShowFiles()
        this.selectAllFiles(false)
      },

      // Upload das imagens
      changeDataAverbacaoAll (val) {
        this.dataAverbAll = val

        if ([6,7,8,9,10].indexOf(this.perfil) != -1) {
          this.selectedFiles.map(item => {
            if (item.flag_isento) {
              item.data_documento = val
            }
          })
        }
      },
      removeFiles () {
        const filesSelected = []
        this.selectedFiles.forEach(function (selected, index) {
          if (selected.flag_isento == false) {
            filesSelected[filesSelected.length] = selected
          }
        })
        this.selectedFiles = filesSelected
        this.selectedShowFiles = filesSelected
      },
      async onClickUpload () {
        await this.uploadFiles()

        const fileObjWithErro = this.selectedFiles.find(fileObj => fileObj.status === STATUS_ERROR)

        if (fileObjWithErro) {
          const textError = 'Processo finalizado, porém ocorreu erro na importação em algum/alguns arquivo(s).' +
            'Confira os arquivos que ocorreram erro e tente importar novamente.' +
            'Caso o erro persistir, entre em contato com o suporte do Sofia.'

          return this.onError(textError)
        }

        return this.onSuccess('Processo finalizado.')
      },
      async uploadFiles () {
        this.isUploading = true

        loader({ text: 'Fazendo Upload de arquivos...', active: true })

        // As requisições de upload devem ser executadas uma de cada vez
        for (let fileObj of this.selectedFiles) {
          delete fileObj.disabled

          try {
            const { data } = await FileUploadService.uploadSofiaRei(fileObj, this.perfil)

            fileObj.arquivo = data.arquivo
            fileObj.status = STATUS_SUCCESS
            fileObj.disabled = true
          } catch (error) {
            fileObj.status = STATUS_ERROR
            fileObj.error = { message: error.response && error.response.data ? error.response.data.message : 'Não foi possível importar essa imagem. Tente novamente.' }
          }
        }

        loader({ text: '', active: false })
      },
      onError (text) {
        this.isUploading = false
        this.uploadComplete = false

        objSwal.error.title = ''
        objSwal.error.text = text
        objSwal.error.html = ''
        loader({ text: '', active: false })
        
        Swal.fire(objSwal.error)

        setTimeout(() => {
          const btnCancel = document.querySelector('.swal2-cancel')

          if (btnCancel) btnCancel.focus()
        }, 200)
      },
      onSuccess (text) {
        this.isUploading = false
        this.uploadComplete = true

        objSwal.success.title = ''
        objSwal.success.text = text
        objSwal.error.html = ''

        loader({ text: '', active: false })
        
        Swal.fire(objSwal.success)

        setTimeout(() => {
          const btnConfirm = document.querySelector('.swal2-confirm')

          if (btnConfirm) btnConfirm.focus()
        }, 200)
      },
      atualizarPerfil (newVal, item) {
        if (!this.selectedFiles.length) return 
        for (const selectedFile of this.selectedFiles) {
          if (selectedFile.registro_id === item.registro_id) selectedFile.codigo_perfil_ged = newVal
        }
      }
    }
  }
</script>
